import { render, staticRenderFns } from "./PolicyScriptCmp.vue?vue&type=template&id=d38e557a&"
import script from "./PolicyScriptCmp.vue?vue&type=script&lang=ts&"
export * from "./PolicyScriptCmp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports